import * as uiAnalyticsConsumer from '@servicenow/ui-analytics-consumer';
const {createTraceId, getConfigValue} = uiAnalyticsConsumer;

function isTracingEnabled() {
	return getConfigValue('enableTrace') === true;
}

export default function createTransactionId() {
	if (!isTracingEnabled()) {
		return null;
	}
	return createTraceId();
}
